import revive_payload_client_4sVQNw7RlN from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import _64nuxt_scripts_D34jXE4xNh from "/home/runner/work/srov-issuer-app/srov-issuer-app/.nuxt/modules/@nuxt-scripts.mjs";
import components_plugin_KR1HBZs4kY from "/home/runner/work/srov-issuer-app/srov-issuer-app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/home/runner/work/srov-issuer-app/srov-issuer-app/.nuxt/sentry-client-config.mjs";
import strapi_CICqBBANNd from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/@nuxtjs/strapi/dist/runtime/plugins/strapi.mjs";
import switch_locale_path_ssr_8BKffvaEi5 from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.mjs";
import i18n_yfWm7jX06p from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_tLmAP220nC from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/@nuxt/image/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/srov-issuer-app/srov-issuer-app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import api_63unc3ZgNJ from "/home/runner/work/srov-issuer-app/srov-issuer-app/plugins/api/api.ts";
import current_version_client_y7SLdRQfzX from "/home/runner/work/srov-issuer-app/srov-issuer-app/plugins/current-version.client.ts";
import sentry_client_shVUlIjFLk from "/home/runner/work/srov-issuer-app/srov-issuer-app/plugins/sentry.client.ts";
import svgSprite_client_NXGsy3rR9P from "/home/runner/work/srov-issuer-app/srov-issuer-app/plugins/svgSprite.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  _64nuxt_scripts_D34jXE4xNh,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  strapi_CICqBBANNd,
  switch_locale_path_ssr_8BKffvaEi5,
  i18n_yfWm7jX06p,
  plugin_tLmAP220nC,
  chunk_reload_client_UciE0i6zes,
  api_63unc3ZgNJ,
  current_version_client_y7SLdRQfzX,
  sentry_client_shVUlIjFLk,
  svgSprite_client_NXGsy3rR9P
]